import { Focusable } from '@studio/design-system/focusable';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { BaseProps } from './types.js';

/** `<Base>` card component. */
export const Base = ({ children, className, ...props }: BaseProps): ReactElement => (
  <Focusable
    className={twMerge('cursor-pointer rounded border border-base-100', className)}
    {...props}
  >
    {children}
  </Focusable>
);
